import Model from "@/lib/model/model";
import { SectionConfig } from "@/lib/model/exambuilder/exam-component/exam";
import { NonessentialComponent } from "@/lib/model/exambuilder/exam-component/common";

export class DimensionParams extends Model {
  id = 0;
  segScore: number[] = [0];
}

export class TacPsycConfig extends Model {
  sectionPageConfig = new SectionConfig();
  id = 0;
  segScore = [95, 90]; // 冗余字段
  selectDimensionIds: number[] = [];
  questionGroupSelection = 0;
  questionResort = 0;
  dimensionParams: DimensionParams[] = [];

  get segScoreStr() {
    return this.segScore.map(item => item + "%");
  }

  public objectArrayClasses() {
    return {
      selectDimensionIds: 0,
      dimensionParams: DimensionParams
    };
  }
}

export class TacPsyc extends NonessentialComponent {
  componentSort = 0;
  configDataList: TacPsycConfig[] = [];

  public objectArrayClasses() {
    return {
      configDataList: TacPsycConfig
    };
  }
}
